import React, { useState, useEffect } from "react";
import Header from "../../component/Header";
import Sidebar from "../../component/SideBar";
import { ToastContainer, toast } from "react-toastify";
import {
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Avatar
} from '@mui/material';
import { Person, Email, Home, Transgender, CloudUpload } from '@mui/icons-material';
import Apiconnection from "../../utils/Apiconnection";
import Loader from "../../utils/Loader";
import { image } from "../../common/Theme";

const Profile = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);

  const [userData, setUserData] = useState({
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    address: '',
    profileImage: null,
    roleId: '',
    dialCode: '',
    phone: '',
    dob: null,
    moduleAccess: []
  });

  const [imageUrl, setImageUrl] = useState(null);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    gender: ""
  });


  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  const sanitize = (val) => (val === null || val === 'null' || val === undefined) ? '' : val;

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };



  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await Apiconnection.post('user-details', { id: userInfo?.id });
        if (response?.data?.status) {
          const data = response.data.data;
          // Sanitize null values to empty strings
          const sanitizedData = {
            ...data,
            firstName: sanitize(data.firstName),
            lastName: sanitize(data.lastName),
            email: sanitize(data.email),
            gender: sanitize(data.gender),
            address: sanitize(data.address),
            dialCode: sanitize(data.dialCode),
            phone: sanitize(data.phone),
          };

          setUserData(sanitizedData);
          if (data.profileImage) {
            setImageUrl(response.data.data.userImageUrl + data.profileImage);
          }
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        toast.error("Failed to fetch profile details");
      } finally {
        setFetchLoading(false);
      }
    };

    if (userInfo?.id) {
      fetchUserDetails();
    }
  }, [userInfo?.id]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     if (file.size > 5 * 1024 * 1024) { // 5MB limit
  //       toast.error("File is too large. Please select an image under 5MB.");
  //       return;
  //     }
  //     setSelectedFile(file);
  //     setImageUrl(URL.createObjectURL(file));
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!userData.firstName) {
      newErrors.firstName = "First name is required";
    }
    if (!userData.lastName) {
      newErrors.lastName = "Last name is required";
    }
    if (!userData.gender) {
      newErrors.gender = "Gender is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    const formData = new FormData();
    formData.append('id', userData.id);
    formData.append('firstName', sanitize(userData.firstName));
    formData.append('lastName', sanitize(userData.lastName));
    formData.append('email', sanitize(userData.email));
    formData.append('gender', sanitize(userData.gender));
    // Check if address exists before appending or append empty string
    formData.append('address', sanitize(userData.address));
    formData.append('roleId', userData.roleId);
    formData.append('dialCode', sanitize(userData.dialCode));
    formData.append('phone', sanitize(userData.phone));
    formData.append('dob', sanitize(userData.dob));
    formData.append('moduleAccess', JSON.stringify(userData.moduleAccess));

    // if (selectedFile) {
    //   formData.append('profileImage', selectedFile);
    // }

    try {
      const response = await Apiconnection.post('user-add-update', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response?.data?.status) {
        toast.success("Profile updated successfully");
        // Update localStorage if needed
        const updatedUser = { ...userInfo, ...userData };
        if (response.data.data.profileImage) {
          updatedUser.profileImage = response.data.data.profileImage;
        }
        localStorage.setItem('userInfo', JSON.stringify(updatedUser));
      } else {
        toast.error(response?.data?.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  console.log("userData ", userData)

  if (fetchLoading) return <Loader />;

  return (
    <div className="grid-container">
      <ToastContainer />
      <Header OpenSidebar={OpenSidebar} />
      <Sidebar
        openSidebarToggle={openSidebarToggle}
        OpenSidebar={OpenSidebar}
      />
      <Box component="main" className="main-container" sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <Card sx={{ borderRadius: '15px', boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)' }}>
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600, mb: 4, color: '#333' }}>
                  My Profile
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={4}>
                    {/* Profile Image Section */}
                    <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
                      <Box sx={{ position: 'relative', mb: 2 }}>
                        <Avatar
                          src={imageUrl || image.userimage}
                          sx={{ width: 120, height: 120, border: '4px solid #13D3A9' }}
                        />
                        {/* <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="profile-image-upload"
                          type="file"
                          onChange={handleImageChange}
                        />
                        <label htmlFor="profile-image-upload">
                          <IconButton
                            color="primary"
                            component="span"
                            sx={{
                              position: 'absolute',
                              bottom: 0,
                              right: 0,
                              backgroundColor: '#fff',
                              boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
                              '&:hover': { backgroundColor: '#f0f0f0' }
                            }}
                          >
                            <CloudUpload sx={{ color: '#13D3A9' }} />
                          </IconButton>
                        </label> */}
                      </Box>
                      {/* <Typography variant="body2" color="textSecondary">
                        Click the upload button to change profile picture
                      </Typography> */}
                    </Grid>

                    {/* Form Fields */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="First Name"
                        name="firstName"
                        variant="outlined"
                        value={userData.firstName || ''}
                        onChange={handleChange}
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Person sx={{ color: '#13D3A9' }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Last Name"
                        name="lastName"
                        variant="outlined"
                        value={userData.lastName || ''}
                        onChange={handleChange}
                        error={!!errors.lastName}
                        helperText={errors.lastName}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Person sx={{ color: '#13D3A9' }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        variant="outlined"
                        value={userData.email || ''}
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Email sx={{ color: '#13D3A9' }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#f5f5f5' } }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth error={!!errors.gender} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}>
                        <InputLabel>Gender</InputLabel>
                        <Select
                          label="Gender"
                          name="gender"
                          value={userData.gender || ''}
                          onChange={handleChange}
                          startAdornment={
                            <InputAdornment position="start">
                              <Transgender sx={{ color: '#13D3A9', mr: 1 }} />
                            </InputAdornment>
                          }
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Others">Other</MenuItem>
                        </Select>
                        {errors.gender && <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>{errors.gender}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        multiline
                        rows={3}
                        variant="outlined"
                        value={userData.address || ''}
                        onChange={handleChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 1.5 }}>
                              <Home sx={{ color: '#13D3A9' }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} display="flex" justifyContent="center">
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                        sx={{
                          minWidth: '200px',
                          py: 1.5,
                          backgroundColor: '#13D3A9',
                          borderRadius: '10px',
                          textTransform: 'none',
                          fontSize: '16px',
                          fontWeight: 600,
                          '&:hover': {
                            backgroundColor: '#00008d',
                          }
                        }}
                      >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Save Changes"}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Profile;
